<template>
    <div class="detail-card">
        <div class="filters-bar">
            <select-option-students icon-only-mobile :custom-options="scopeOptions" :value="scope"
                @change="onScopeChange" />

            <div v-if="showScopePicker" class="scope-picker">
                <kimsa-combobox v-if="isGroups" :key="`g-${coachId}`" dense solo with-selected-dot :items="groups"
                    :value="currentGroup" item-value="id" :loading="binding" :readonly="binding"
                    :placeholder="$t('common.select_placeholder')" @change="onSelectGroup" />
                <kimsa-combobox v-else :key="`t-${coachId}`" dense solo with-selected-dot :items="teams"
                    :value="currentTeam" item-value="id" :loading="binding" :readonly="binding"
                    :placeholder="$t('common.select_placeholder')" @change="onSelectTeam" />
            </div>
        </div>

        <div class="detail-body">
            <coach-students-table v-if="isStudents" :coach-id="coachId" />

            <div v-else-if="binding" class="empty-state">
                {{ $t('common.loading') }}
            </div>
            <div v-else-if="isGroups && !groups.length" class="empty-state">
                {{ $t('company.coach_without_groups') }}
            </div>
            <coach-group-detail v-else-if="isGroups && currentGroup" :key="currentGroup.id"
                :group="currentGroup" />
            <div v-else-if="isTeams && !teams.length" class="empty-state">
                {{ $t('company.coach_without_teams') }}
            </div>
            <coach-team-detail v-else-if="isTeams && currentTeam" :key="currentTeam.id" :team="currentTeam"
                :coach-id="coachId" />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import SelectOptionStudents from "@/components/coach/SelectOptionStudents";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import CoachStudentsTable from "@/components/company/home/CoachStudentsTable";
import CoachGroupDetail from "@/components/company/home/CoachGroupDetail";
import CoachTeamDetail from "@/components/company/home/CoachTeamDetail";

export default {
    name: "CoachDetailPanel",
    components: { SelectOptionStudents, KimsaCombobox, CoachStudentsTable, CoachGroupDetail, CoachTeamDetail },
    props: {
        coachId: {
            type: String,
            default: null,
        },
        binding: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            scope: 'student',
            groupId: null,
            teamId: null,
        }
    },
    computed: {
        ...mapState(['groups', 'teams']),
        scopeOptions(vm = this) {
            return [
                { name: vm.$t('common.students'), value: 'student', icon: 'mdi-account' },
                { name: vm.$t('common.groups'), value: 'group', icon: 'mdi-account-multiple' },
                { name: vm.$t('common.teams'), value: 'team', icon: 'mdi-account-group' },
            ]
        },
        isStudents(vm = this) {
            return vm.scope === 'student'
        },
        isGroups(vm = this) {
            return vm.scope === 'group'
        },
        isTeams(vm = this) {
            return vm.scope === 'team'
        },
        showScopePicker(vm = this) {
            if (vm.isStudents) return false
            if (vm.binding) return true
            return vm.isGroups ? vm.groups.length > 0 : vm.teams.length > 0
        },
        currentGroup(vm = this) {
            return vm.groups.find(group => group.id === vm.groupId) || vm.groups[0] || null
        },
        currentTeam(vm = this) {
            return vm.teams.find(team => team.id === vm.teamId) || vm.teams[0] || null
        },
    },
    methods: {
        onScopeChange(scope) {
            this.scope = scope
        },
        onSelectGroup(group) {
            this.groupId = group?.id || null
        },
        onSelectTeam(team) {
            this.teamId = team?.id || null
        },
    },
    watch: {
        coachId() {
            const vm = this
            vm.scope = 'student'
            vm.groupId = null
            vm.teamId = null
        },
    },
}
</script>

<style scoped>
.detail-card {
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 14px;
    overflow: hidden;
    margin-top: 16px;
}

.filters-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 18px;
    flex-wrap: wrap;
}

.scope-picker {
    width: 220px;
    flex-shrink: 0;
}

.detail-body {
    padding: 0 18px 18px;
}

.empty-state {
    padding: 32px 16px;
    text-align: center;
    font-size: 12px;
    color: var(--v-txtMuted-base);
    background: var(--v-surface2-base);
    border: 1px dashed var(--v-outline2-base);
    border-radius: 12px;
}

@media (max-width: 600px) {
    .scope-picker {
        width: 100%;
    }
}
</style>
